var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionLength16({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0V9H3v1a1 1 0 1 1-2 0V6a1 1 0 0 1 2 0v1h10V6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionLength16);
export default __webpack_public_path__ + "static/media/ic_action_length_16.d8f48e0d0033546ff453a7994a222924.svg";
export { ForwardRef as ReactComponent };